import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { Document } from '@contentful/rich-text-types';

import { makeOptions } from './';

export function TextRichText(props: { json: Document; className?: string }) {
  const { json, className } = props;
  if (!json) return null;

  const rt = documentToReactComponents(json, makeOptions(className));
  return <>{rt}</>;
}
